import { render, staticRenderFns } from "./Branch_information.vue?vue&type=template&id=43ef42f6&scoped=true&"
import script from "./Branch_information.vue?vue&type=script&lang=js&"
export * from "./Branch_information.vue?vue&type=script&lang=js&"
import style0 from "./Branch_information.vue?vue&type=style&index=0&id=43ef42f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ef42f6",
  null
  
)

export default component.exports